import {GetTetraResources} from '../../Comman/apiEndPoints';
import varAxios from "../../Comman/axios";
import formDataAxios from "../../Comman/formDataAxios";

export const FETCH_TETRA_RESOURCES_LIST_REQUEST = "FETCH_TETRA_RESOURCES_LIST_REQUEST";
export const FETCH_TETRA_RESOURCE_LIST_SUCCESS = "FETCH_TETRA_RESOURCE_LIST_SUCCESS";


 
export function fetchTetraResourcesList(dispatch) { 
  return (dispatch) => {
      dispatch(fetchTetraResourcesListRequest(true));

      return varAxios.get(GetTetraResources)
          .then((response) => { 
              dispatch(
                fetchTetraResourcesListSuccess(false, response.data.tetraResourceList)
              );
          })
          .catch((error) => {
          })
  }
}

export function fetchTetraResourcesListRequest(isLoading) {
  return {
      type: FETCH_TETRA_RESOURCES_LIST_REQUEST,
      isLoading
  }
}

export function fetchTetraResourcesListSuccess(isLoading, tetraResourceList) {   
  return {
      type: FETCH_TETRA_RESOURCE_LIST_SUCCESS,
      isLoading,
      tetraResourceList
  }
}




